import { store } from './redux/store'
import authSelectors from './redux/modules/auth/selectors'

export const routes = {
  blank: '/blank',
  home: '/',
  onboarding: '/onboarding',
  retries: '/retries',
  awaitEmailVerification: '/await-email-verification',
  verify: '/verify',
  welcome: '/welcome',
  resetPasswordSuccess: '/reset-password-success',
  resetPassword: '/reset-password',
  login: '/login',
  tokenLogin: '/token-login',
  register: '/register',
  accessDenied: '/access-denied',
  companyPlanningRecordLetters: '/letters',
  companyPlanningRecord: (companyPlanningRecordId?: string) => {
    if (!companyPlanningRecordId) {
      companyPlanningRecordId = ':companyPlanningRecordId'
    } else {
      const companyId = authSelectors.getCompanyId(store.getState())
      const companyPrefix = `${companyId}_`
      if (companyPlanningRecordId.startsWith(companyPrefix)) {
        companyPlanningRecordId = companyPlanningRecordId.slice(companyPrefix.length)
      }
    }
    return `/letters/${companyPlanningRecordId}`
  },
  planningRecords: '/planning-records',
  planningRecord: (planningRecordId: string = ':planningRecordId') =>
    `/planning-records/${planningRecordId}`,
  filters: '/filters',
  subscription: '/subscription',
  companyPayments: '/invoices',
  letterTemplate: '/letter-template',
  map: '/map',
  template: '/template',
} as const

export const publicRoutes = [
  routes.welcome,
  routes.login,
  routes.tokenLogin,
  routes.register,
  routes.resetPassword,
  routes.resetPasswordSuccess,
  routes.verify,
] as const

export const privateRoutes = [
  routes.home,
  routes.onboarding,
  routes.retries,
  routes.awaitEmailVerification,
  routes.companyPlanningRecordLetters,
  routes.companyPlanningRecord(),
  routes.planningRecords,
  routes.planningRecord(),
  routes.filters,
  routes.subscription,
  routes.companyPayments,
  routes.letterTemplate,
  routes.map,
] as const

export const overlayRoutes = [
  {
    path: routes.companyPlanningRecord(),
    defaultBackdrop: routes.blank,
    defaultBack: routes.companyPlanningRecordLetters,
  },
  {
    path: routes.planningRecord(),
    defaultBackdrop: routes.blank,
    defaultBack: routes.planningRecords,
  },
  {
    path: routes.template,
    defaultBackdrop: routes.blank,
    defaultBack: routes.home,
  },
  { path: routes.filters, defaultBackdrop: routes.home, defaultBack: routes.home },
  { path: routes.subscription, defaultBackdrop: routes.home, defaultBack: routes.home },
  { path: routes.companyPayments, defaultBackdrop: routes.home, defaultBack: routes.home },
  { path: routes.letterTemplate, defaultBackdrop: routes.home, defaultBack: routes.home },
  { path: routes.map, defaultBackdrop: routes.home, defaultBack: routes.home },
] as const

export const invalidOverlayBackdropRoutes = [
  ...publicRoutes,
  routes.onboarding,
  routes.awaitEmailVerification,
  routes.accessDenied,
  routes.blank,
] as const

export const getFromOrDefault = (route: string, from?: string) => {
  return from && privateRoutes.includes(from) ? from : route
}
